<template>
  <v-col cols="12">
    <v-form @submit.prevent="save" lazy-validation v-model="valid" ref="form">
      <v-card tile flat outlined class="mx-1">
        <v-card-title>
          <p> {{ titulo }} </p>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="formularioEditor.orgao"
                label="Orgão"
                rows="1"
                filled
                auto-grow
                :rules="[(v) => !!v || 'Orgão é obrigatório.']"
              ></v-textarea>
            </v-col>

            <v-col cols="6">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dataFormatada"
                    label="Data"
                    filled
                    :rules="requiredRule"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    @blur="formularioEditor.data = coverterData(dataFormatada)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formularioEditor.data"
                  no-title
                  locale="pt-br"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-textarea
                v-model="formularioEditor.hora"
                label="Hora"
                rows="1"
                filled
                auto-grow
                :rules="[(v) => !!v || 'Hora é obrigatório.']"
              ></v-textarea>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="formularioEditor.objeto"
                label="Objeto"
                rows="1"
                filled
                auto-grow
                :rules="[(v) => !!v || 'Objeto é obrigatório.']"
              ></v-textarea>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="formularioEditor.relator"
                label="Relator"
                rows="1"
                filled
                auto-grow
                :rules="[(v) => !!v || 'Relator é obrigatório.']"
              ></v-textarea>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="formularioEditor.interlocutores"
                label="Interlocutores"
                rows="1"
                filled
                auto-grow
                :rules="[(v) => !!v || 'Interlocutores é obrigatório.']"
              ></v-textarea>
            </v-col>
            
          </v-row>
        </v-card-text>
        <v-card-actions v-if="permissao" class="mx-1 ml-2 mt-n4">
          <v-btn :loading="isFetching" type="submit" color="success text-center" small>{{ isUpdate ? "Salvar alterações" : "Criar" }}</v-btn>
          <v-btn @click.prevent="cancel" color="error text-center" small>Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-col>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  props: {
    formulario: {
      type: Object,
      required: false,
    },
    lancamento: {
      type: Object,
      required: false,
    },    
    permissao: {
      required: false,
    },
  },

  watch: {
    'formularioEditor.data' () {
      this.dataFormatada = this.formatarData(this.formularioEditor.data)
    },
  },

  data() {
    return {
      formularioEditor: this.formulario ? Object.assign({}, this.formulario) : this.formularioEditorReset(),
      valid: true,
      requiredRule: [(v) => !!v || "Campo obrigatório"],
      errorMessage: "",
      dataFormatada: '',
      menu1: false,
    };
  },

  computed: {
    ...mapState('formulario', {
      isFetching: state => state.isFetching,
    }),       
    isUpdate() {
      return !!this.formulario;
    },
    titulo() {
      return this.isUpdate ? "Editar Informe de Reunião " : "Novo Informe de Reunião " 
    },

  },
  methods: {
    ...mapActions('formulario', ['criarFormulario', 'editarFormulario']),

    save() {
      if(this.$refs.form.validate()) {
        this.persist().then((formulario) => {
          this.$refs.form.resetValidation()
          this.formularioEditor = this.formularioEditorReset();
          this.$emit("save", { formulario });          
        })
         .catch((error) => {
           if (error.response) {
             this.errorMessage = error.response.data
           }
         })
         .finally(() => { this.$emit("save"); });

      }
    },
    persist() {
      return this.isUpdate ? this.update() : this.create();
    },
    create() {
      const payload = {
        "indicadorId": this.lancamento.indicador.id,
        "lancamentoId": this.lancamento.id,
        "formulario": this.formularioEditor,
        'urlFormulario': '/informe-reuniao',
        'mensagemSucesso': 'Informe de Reunião salvo com sucesso'
      }
      return this.criarFormulario(payload)
    },
    update() {
      this.formularioEditor.lancamentoFonte = {}
      const payload = {
        "indicadorId": this.formulario.lancamentoFonte.indicador.id, 
        "lancamentoId": this.formulario.lancamentoFonte.id, 
        "formularioId": this.formulario.id, 
        "formulario": this.formularioEditor,
        'urlFormulario': '/informe-reuniao',
        'mensagemSucesso': 'Informe de Reunião editado com sucesso'
      }      
      return this.editarFormulario(payload);
    },
    cancel() {
      this.$refs.form.reset();
      this.$emit("cancel");
    },
    formularioEditorReset() {
      return {data: ''};
    },
    formatarData (data) {
      if (!data) return null

      const [ano, mes, dia] = data.split('-')
      return `${dia}/${mes}/${ano}`
    },
    coverterData (data) {
      if (!data) return null

      const [dia, mes, ano] = data.split('/')
      return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
  },

  created() {
    this.dataFormatada = this.formatarData(this.formularioEditor.data)
  },
};
</script>

<style scoped>
</style>
